import React from 'react';
import GridLayout from '../../../../../../shared/ui/GridLayout';
import SelectAcceptanceDuration from '../../../../../../controllers/base/SelectAcceptanceDuration';
import { fieldPathBuilders } from '../../../../../../shared/configs/acceptanceForm';
import { useSyncClassicTimes } from '../../../../../../controllers/ClassicSetupIntervals';
import TimesSelection from './TimesSelection';
import { useDayIsImmutable } from '../../../../hooks/isImmutableFns';
import { useTimeIntervals } from '../../../../../../services/timeIntervals';

const {
  start: createStartName,
  end: createEndName,
  duration: createDurationName,
} = fieldPathBuilders.deskScheduleSetting;

const ClassicTab = ({ deskIndex, entityKey, children }) => {
  const timeIntervals = useTimeIntervals();

  const dayImmutable = useDayIsImmutable(deskIndex, entityKey);

  const startName = createStartName(deskIndex, entityKey);
  const endName = createEndName(deskIndex, entityKey);
  const durationName = createDurationName(deskIndex, entityKey);

  const syncTimes = useSyncClassicTimes(() => ({
    startName,
    endName,
    controller: timeIntervals,
  }));

  const disabled = useDayIsImmutable(deskIndex, entityKey);

  return (
    <>
      <GridLayout minWidth="200px" gap="20px" adaptive>
        <SelectAcceptanceDuration
          label="Продолжительность приемки"
          name={durationName}
          changeCb={syncTimes}
          durations={timeIntervals.durations}
          disabled={disabled}
        />
        <TimesSelection
          startName={startName}
          endName={endName}
          durationName={durationName}
          immutable={dayImmutable}
        />
      </GridLayout>
      {children}
    </>
  );
};

export default ClassicTab;
